// regularTaskScheduler handles regenerating the next instance of a recurring task.
// Splitting it out keeps the main focus-mode hook below 500 lines and easier to read.

import { db, sql, TaskWithContext } from '../../lib/db';
import { calculateNextDueDate } from '../../lib/dateUtils';

export async function ensureNextRegularTaskInstance(task: TaskWithContext, userId: string) {
  const frequency = task.frequency || 'Daily';

  let currentDueDate: Date;
  if (task.next_due_date) {
    const dateValue = task.next_due_date;
    if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
      currentDueDate = new Date(dateValue + 'T00:00:00.000Z');
    } else {
      const dateStr = new Date(dateValue).toISOString().split('T')[0];
      currentDueDate = new Date(dateStr + 'T00:00:00.000Z');
    }
  } else {
    const dateStr = new Date(task.start_date || new Date()).toISOString().split('T')[0];
    currentDueDate = new Date(dateStr + 'T00:00:00.000Z');
  }

  const nextDueDate = calculateNextDueDate(currentDueDate, frequency, task.recurrence_day);
  const nextDueDateString = nextDueDate.toISOString().split('T')[0];

  const existingNextTask = await sql`
    SELECT id, title, start_date, next_due_date, frequency, status FROM tasks
    WHERE user_id = ${userId}
    AND LOWER(TRIM(title)) = LOWER(TRIM(${task.title}))
    AND LOWER(TRIM(COALESCE(description, ''))) = LOWER(TRIM(COALESCE(${task.description || ''}, '')))
    AND frequency = ${frequency}
    AND is_regular = true
    AND status != 'Complete'
    AND (
      next_due_date = ${nextDueDateString}::date
      OR DATE(start_date AT TIME ZONE 'UTC') = ${nextDueDateString}
    )
    LIMIT 1
  `;

  if (existingNextTask.length > 0) {
    return;
  }

  try {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const nextDueDateMidnight = new Date(nextDueDate);
    nextDueDateMidnight.setHours(0, 0, 0, 0);
    const isToday = nextDueDateMidnight.getTime() === today.getTime();

    await db.tasks.create({
      ...task,
      id: undefined as any,
      created_at: undefined as any,
      updated_at: undefined as any,
      start_date: nextDueDate,
      next_due_date: nextDueDate,
      status: 'To Do' as const,
      end_date: undefined,
      is_live: isToday
    });
  } catch (error) {
    console.error('Error creating next regular task instance:', error);
  }
}
